module.exports = __webpack_public_path__ + "img/mobile-download.27bc92a9.png";